import React, { useCallback, useEffect, useState } from 'react';
import MTable from '../../../../../Components/MTable/MTable';
import { useIntl } from 'react-intl';
import { Container } from '../../../../../Components/Container/Container';
import { useAptorApi } from '../../../../../Api';
import { Query } from '@material-table/core';
import { IGridQueryRequest, OrderDirection } from '../../../../../Api/AptorApi';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import moment from 'moment';
import { useStyles } from "../../../AptorAdminModule.styles";
import { Button, Tooltip } from '@material-ui/core'
import { ArrowUpward } from '@material-ui/icons'
import { useFilter } from '../../../../../Components/ListFilter';
import { HtmlView, RepealableName } from '../../../../../Components';
import { useConfirmation } from '../../../../../Context/ConfirmationContext/ConfirmationContext';
import { InformationBoardFilter } from './Filter';



export const InformationBoard = () => {
  const { formatMessage } = useIntl();
  const { api, abortController } = useAptorApi();
  const [filters, setFilter] = useFilter();
  const tableRef = React.useRef<any>(null);
  const navigate = useNavigate();
  const classes = useStyles()
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const { deleteConfirmation } = useConfirmation();
  const shouldTriggerRefresh = React.useRef(false);

  useEffect(() => {
    if (shouldTriggerRefresh.current) {
      tableRef.current && (tableRef.current as any).onQueryChange();
    }
    shouldTriggerRefresh.current = true;
  }, [filters]);

  const renderDate = (date?: Date) => {
    return date ? moment(date).format('ll') : undefined;
  };

  const [showScrollTop, setShowScrollTop] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  useEffect(() => {
    const updatedQueryParams = Object.keys(filters)
      .filter(key => filters[key]?.join() !== undefined && filters[key]?.join() !== "")
      .map(key => `${key}=${encodeURIComponent(filters[key]?.join())}`)
      .join('&');
    navigate({
      pathname: location.pathname,
      search: `?${updatedQueryParams}`,
    }, { replace: true });
  }, [filters, navigate, location.pathname]);

  const filtersRef = React.useRef(filters);
  
  React.useEffect(() => {
    filtersRef.current = filters;
  }, [filters]);

  const handleDataFetch = useCallback(
    async (query: Query<any>) => {
      return await api.searchAnnouncements<any>({
        orderDirection: query.orderDirection === 'desc' ? OrderDirection.Descending : query.orderDirection === "asc" ? OrderDirection.Ascending : OrderDirection.Descending,
        orderBy: query.orderBy !== undefined ? query.orderBy.field : 'CreatedAt',
        page: query.page,
        pageSize: query.pageSize,
        search: query.search,
        filters: filtersRef.current,
      } as IGridQueryRequest);

    },
    [api],
  );
  const stripHtml = (html: string) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || '';
  };
  return (
    <>
      <Container fullWidth linkButtonTo="/admin/law-portal/information-board/new" linkButtonLabel="admin.law-portal.add-informationBorad">
      <InformationBoardFilter setFilter={setFilter} />
        <MTable
          tableRef={tableRef}
          columns={[
            { title: formatMessage({ id: 'admin.law-portal.informationBorad.table.Headline' }), field: 'headline' },
            {
              title: formatMessage({ id: 'admin.law-portal.informationBorad.table.informationtext' }),
              field: 'message',
              render: (row: any) => <>
                <span >{stripHtml(row.message)}</span>
                ,{" "}
                <Link to={row.url} target="_blank" >
                  {row.urlName||formatMessage({ id: "admin.law-portal.informationboard.form.urlName.placeholder" })}
                </Link>
              </>
            },
            {
              title: formatMessage({ id: 'admin.law-portal.informationBorad.table.createDate' }),
              field: 'createdAt',
              render: (row: any) => renderDate(row?.createdAt),
            },
          ]}
          data={handleDataFetch}
          actions={[
            (row) => ({
              tooltip: formatMessage({ id: 'component.mtable.editTooltip' }),
              icon: 'edit',
              onClick: () => navigate(`/admin/law-portal/information-board/${row.id}`),
            }),
            (row) =>
              row?.status === true
                ? {
                  tooltip: formatMessage({ id: 'admin.lawportal.informationBoard.inactivate.label' }),
                  icon: 'block',
                  onClick: async () => {
                    await api.toggleAnnouncementActivation(row?.id, false);
                    if (abortController.current.signal.aborted) {
                      return;
                    }
                    (tableRef.current as any).onQueryChange();
                  },
                }
                : {
                  tooltip: formatMessage({ id: 'admin.lawportal.informationBoard.activate.label' }),
                  icon: 'check',
                  onClick: async () => {
                    await api.toggleAnnouncementActivation(row?.id, true);
                    if (abortController.current.signal.aborted) {
                      return;
                    }
                    (tableRef.current as any).onQueryChange();
                  },
                },
            (row) => ({
              tooltip: formatMessage({ id: 'component.mtable.deleteTooltip' }),
              icon: 'delete',
              onClick: async () => {
                const currentTableRef = tableRef.current as any;

                deleteConfirmation(
                  async () => {
                    await api.deleteAnnouncement(row.id);
                    if (abortController.current.signal.aborted) {
                      return;
                    }
                    currentTableRef.onQueryChange();
                  },
                  {
                    description: formatMessage({ id: 'admin.lawportal.informationboard.table.action.deleteinformation.confirmation' }),
                  },
                );
              }
            }),

          ]}
          components={{}}
        />
      </Container>
      {showScrollTop && (
        <Tooltip title={formatMessage({ id: "bottom.to.top.btn.tooltip.text", defaultMessage: "Back to top" })}>
          <Button
            onClick={() => {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            className={classes.topButton}
          >
            <ArrowUpward style={{ fontSize: 20 }} />
          </Button>
        </Tooltip>
      )}

    </>
  );
};
